<template>
  <Container type="card-full">
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="true" :resizable="true"
            :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject"  @pagechange="pagechange">
        <template slot="btn">
          <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'pgsuIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false},
          // { field: 'projectdesc', fieldtype: 'C', title: '采购内容',calculExpr:'',addNewRowFlg: false},
          { field: 'projecttime', fieldtype: 'T', title: '建项时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', 'yyyy-MM-dd'], width: 100}
        ],
        project: {},
        query: {
          cosid: this.$store.getters.loginUser.cosid,
          userid: this.$store.getters.loginUser.userid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('SETPGSU', () => this.setPgsu())
    },
    activated() {
      this.init()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)

      },
      async init() {
        this.query = {
          cosid: this.$store.getters.loginUser.cosid,
          userid: this.$store.getters.loginUser.userid,
          total: 0,
          limit: 20,
          offset: 0}
        this.list = []
        this.btnLoading = false
        this.project = {}
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async setPgsu() {
        if (!this.project.projectid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        this.$router.push({name: 'pgsuForm', params: {form: this.project, type: 1}})
      },
      async cellClick (row) {
        this.project = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async viewProject(row) {
        this.project = row.row
        this.$router.push({name: 'pgsuForm', params: {form: this.project, type: 1}})
      },
      async getPageList () {
        console.log(this.query)
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/pgs/getProjectList',
          params: this.query
        })
        res.list.forEach(key => {
          if(key.projectstatus > 30)
            this.list.push(key)
        })
        console.log(res)
        // this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
